// Attribution: https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react#sign-in-users

// Dependencies
import React from "react";

// MSAL
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "@/config/authConfig";

// Material
import { Button } from "@mui/material";

/**
 * Renders a button which, when selected, will redirect the page to the login prompt
 */
const SignInButton: React.FC = () => {
  const { instance } = useMsal();

  // SignIn button click event handler
  const handleLogin = () => {
    if (!instance) return;

    // add deep linking redirect path into azure state
    const state = sessionStorage.getItem("msalState");
    if (state) {
      // Create a new request object to avoid modifying the original
      const request = { ...loginRequest, state };
      instance.loginRedirect(request).catch((error) => {
        console.error(error);
      });
    } else {
      instance.loginRedirect(loginRequest).catch((error) => {
        console.error(error);
      });
    }
  };

  return (
    <Button
      size="large"
      variant="outlined"
      color="primary"
      aria-label="Sign in"
      sx={{ overflow: "hidden", textTransform: "none" }}
      onClick={handleLogin}
    >
      myID
    </Button>
  );
};

export { SignInButton };
